// API константы
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth',
    VERIFY: '/auth/verify',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout'
  },
  
  // Пользователи
  USER: {
    PROFILE: '/user',
    PERSONAL_DATA: '/user/personal-data',
    FNS_TOGGLE: '/user/fns/enable',
    FNS_AUTH: '/user/fns',
    FNS_VERIFY: '/user/fns/verify',
    MTS: '/user/mts',
    MTS_VERIFY: '/user/mts/verify',
    RIM: '/user/rim',
    RIM_VERIFY: '/user/rim/verify',
    CARDS: '/user/cards',
    CARD_ADD: '/user/card/add',
    CARD_DELETE: '/user/card'
  },
  
  // Сделки
  DEAL: {
    LIST: '/deal/list',
    CREATE: '/deal/create',
    DELETE: '/deal',
    GET_BY_ID: '/deal',           // GET /deal/{id}
    PAY: '/deal',                 // POST /deal/{id}/pay
    REFUND: '/deal',              // POST /deal/{id}/refund
    CONFIRM: '/deal',             // POST /deal/{id}/confirm
    RECEIPT: '/deal',             // GET /deal/{id}/receipt?token=
    PAYER_CONFIRM: '/deal',       // POST /deal/{id}/payer-confirm?token=
    PAYER_REJECT: '/deal',        // POST /deal/{id}/payer-reject?token=
    SEND_PAYER_EMAIL: '/deal'     // POST /deal/{id}/send-payer-confirm-email
  },
  
  // Другие эндпоинты
  COMMON: {
    HEALTH_CHECK: '/health',
    TEXT_PLAIN: 'text/plain',
  }
} as const;

// HTTP статус коды
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;

// Таймауты
export const TIMEOUTS = {
  REQUEST: 10000, // 10 секунд
  REFRESH_TOKEN: 5000, // 5 секунд для обновления токена
  SESSION_CHECK: 5 * 60 * 1000, // 5 минут для проверки сессии
} as const;

// Локальное хранилище ключи
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_DATA: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
} as const;

// Заголовки
export const HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  AUTHORIZATION: 'Authorization',
  ACCEPT: 'Accept',
} as const;

// MIME типы
export const MIME_TYPES = {
  JSON: 'application/json',
  FORM_DATA: 'multipart/form-data',
  TEXT_PLAIN: 'text/plain',
} as const;
